import { registerBlockType } from "@wordpress/blocks";
const { omit } = lodash;

export {
  generateBackgroundControlStyles,
  generateBackgroundAttributes,
} from "./backgroundHelpers";

export {
  generateTypographyAttributes,
  generateTypographyStyles,
} from "./typoHelpers";

export {
  generateDimensionsAttributes,
  generateDimensionsControlStyles,
} from "./dimensionHelpers";

export {
  generateBorderShadowAttributes,
  generateBorderShadowStyles,
} from "./borderShadowHelpers";

export {
  generateResponsiveRangeStyles,
  generateResponsiveRangeAttributes,
} from "./responsiveRangeHelpers";

export {
  generateResponsiveSelectControlAttributes,
  generateResponsiveSelectControlStyles,
} from "./responsiveSelectControlHelpers";

export {
  textInsideForEdit,
  generateRandomNumber,
  hardMinifyCssStrings,
  softMinifyCssStrings,
  isCssExists,
} from "./miniHelperFuncs";

export {
  handleDesktopBtnClick,
  handleTabBtnClick,
  handleMobileBtnClick,
} from "./handlingPreviewBtnsHelpers";

export {
  mimmikCssForResBtns,
  mimmikCssForPreviewBtnClick,
  mimmikCssOnPreviewBtnClickWhileBlockSelected,
  duplicateBlockIdFix,
} from "./funcsForUseEffect";

export {
  ebImageSizes,
  EbImageSizeSelector
} from "./coreSettings";

export { getFlipTransform, getButtonClasses } from "./flipboxHelpers";



//Check if the string is JSON or plain String
export const ebJsonStringCheck = (string) => {
  try {
    var o = JSON.parse(string);
    if (o && typeof o === "object") {
      return true;
    }
  } catch (e) { }

  return false;
}

/**
 * String to Component Name
 * @param {*} string
 */
export const ebStringToComponentName = (str) => {
  const arr = str.split("_");
  for (var i = 0; i < arr.length; i++) {
    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);

  }
  return arr.join("");
}

/**
 * Conditional Register Block
 */
export const ebConditionalRegisterBlockType = (metadata, settings) => {
  const { name } = metadata;
  if (EssentialBlocksLocalize.eb_wp_version >= 5.8) {
    registerBlockType({ name, ...metadata }, settings);
  } else {
    registerBlockType(`${name}`, {
      ...omit(metadata, ["name"]),
      ...settings,
    });
  }
};
